import { createAsyncThunk } from '@reduxjs/toolkit';
import { $api } from 'shared/api';

interface FetchTasksError {
    message: string;
}
interface TaskIds {
    uid: string;
    entity_uid: string;
}

export const deleteTask = createAsyncThunk<string, TaskIds, { rejectValue: FetchTasksError }>(
    'tasks/deleteTask',
    async (taskIds, thunkApi) => {
        //@ts-ignore
        const url = routable.getRoute('deleteTask');
        try {
            const formattedUrl = url.replace('_customTask_', taskIds.entity_uid);
            const res = await $api.delete<{ message: string }>(formattedUrl);
            return taskIds.uid;
        } catch (error) {
            const fetchError: FetchTasksError = {
                message:
                    error instanceof Error ? error.message : i18next.t('Errors.UnknownError.text'),
            };

            // thunkApi.dispatch(tasksInformationActions.changeError(fetchError.message));
            return thunkApi.rejectWithValue(fetchError);
        }
    }
);
